'use es6';

import ActionTypes from 'AdsUI/lib/Actions';
export const addHeaderBanner = (bannerType, pages, options) => ({
  type: ActionTypes.BANNER_HEADER_ADD,
  bannerType,
  pages,
  options
});
export const removeHeaderBanner = (bannerType, pages) => ({
  type: ActionTypes.BANNER_HEADER_REMOVE,
  bannerType,
  pages
});
export const clearHeaderBanners = () => ({
  type: ActionTypes.BANNER_HEADER_CLEAR_ALL
});
export const addBodyBanner = (bannerType, pages, options) => ({
  type: ActionTypes.BANNER_BODY_ADD,
  bannerType,
  pages,
  options
});
export const removeBodyBanner = (bannerType, pages) => ({
  type: ActionTypes.BANNER_BODY_REMOVE,
  bannerType,
  pages
});
export const clearBodyBanners = () => ({
  type: ActionTypes.BANNER_BODY_CLEAR_ALL
});